import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";

import css from "./Morganlogos.css";


export default function Morganlogos({links}) {
  const imgCDNURL = process.env.REACT_APP_APSECOND;
  const angelAiImg = process.env.REACT_APP_ANGELAI_LOGO;
  return (
    <>
      <div className="logobox">
        <Container>
          <Row className="desktoplogo">
            <Col sm={12} md={12} xl={4} lg={4} className="borderrightcol">
              <a
                href="https://www.celligence.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={imgCDNURL + "celligencelogo.png"}
                  className="cellilog img-fluild"
                ></img>
              </a>
            </Col>
            <Col sm={12} md={12} xl={4} lg={4} className="borderrightcol">
              <a href="https://www.swmc.com/" target="_blank">
                <img
                  src={process.env.REACT_APP_CDN_LINK + "swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"}
                  className="sunlogo img-fluild"
                ></img>
              </a>
            </Col>
            <Col sm={12} md={12} xl={4} lg={4}>
              <a href={links.mobileAppURL} target="_blank">
                <img
                  src={angelAiImg}
                  className="morganlogo img-fluild"
                ></img>
              </a>
            </Col>
            <p className="learnusemorgan">
              Want to learn more? Visit{" "}
              <span className="learntext">
                <a
                  href={links.mobileAppURL}
                  target="_blanck"
                  rel="noreferrer"
                >
                  {links.mobileAppName}
                </a>
              </span>{" "}
              today.
            </p>
          </Row>
          <Row>
            <div className="sunwestlogosmobile">
              <Col sm={12} md={12}>
                <a href={links.mobileAppURL} target="_blank">
                  <img
                    src="https://stagingresources.swmc.com/mastermind/logomorgan.webp"
                    className="morganlogomobile img-fluild"
                  ></img>
                </a>
              </Col>
              <Col sm={12} md={12}>
                <a
                  href="https://www.celligence.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={imgCDNURL + "celleenceblur.png"}
                    className="cellilogmobile img-fluild"
                  ></img>
                </a>
              </Col>
              <Col sm={12} md={12}>
                <a href="https://www.swmc.com/" target="_blank" className="sunlogomobile-link">
                  <img
                    src={process.env.REACT_APP_CDN_LINK + "swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"}
                    className="sunlogomobile img-fluild"
                  ></img>
                </a>
              </Col>
            </div>
          </Row>
        </Container>
        <p className="learnusemorganmobile">
          Want to learn more? Visit{" "}
          <span className="learntext">
            <a
              href={links.mobileAppURL}
              target="_blanck"
              rel="noreferrer"
            >
              {links.mobileAppName}
            </a>
          </span>{" "}
          today.
        </p>
      </div>
    </>
  );
}
